import * as React from "react";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/header-one";
import Footer from "@layout/footer/footer-one";
import DataArea from '@containers/data-area'
import Banner from "@components/banners/Ai";


const OpenDataPage = ({ pageContext, location }) => (
	<Layout location={location}>
		<Seo title="Open Data" />
		<Header />
		<Banner
			pageContext={pageContext}
			location={location}
			title="Open Data"
		/>
		<main className="site-wrapper-reveal">
			<DataArea />
		</main>
		<Footer />
	</Layout>
)

export default OpenDataPage